import React from "react";
import { Layout } from "antd";
import Sidebar from "../components/Sidebar";
import HeaderBar from "../components/HeaderBar"; // create a header component
import { Outlet } from "react-router-dom";

const { Content } = Layout;

export default function MainLayout() {
  return (
    <Layout >
      <Sidebar />
      <Layout>
        <HeaderBar /> {/* ✅ consistent header */}
        <Content style={{ margin: "16px", background: "#fff", padding: "20px" }}>
          <Outlet /> {/* ✅ page content swaps here */}
        </Content>
      </Layout>
    </Layout>
  );
}
